import React, {useEffect, useState} from 'react';
import {Link} from 'react-router-dom';
import { Swiper, SwiperSlide } from 'swiper/react';
// Import Swiper styles
import "swiper/css";

const YouTube = (props) => (
  <Swiper
    slidesPerView={'auto'}
    className="youtubeBox"
    >
    {props.videos.map((video, idx) => {
      return(
        <SwiperSlide className="youtubeList" key={idx}>
          <Link to={"https://www.youtube.com/watch?v="+video.id.videoId} target="_blank" rel="noopener noreferrer">
          <div className="youtubeImg">
            <img src={video.snippet.thumbnails.high["url"]} alt="" />
          </div>
          <div className="youtubeText">{video.snippet.title}</div>
          </Link>
        </SwiperSlide>
      )
    })
    }
  </Swiper>
);

export default YouTube;